import type { AppNotificationProviderProps } from "./app-notification.type";

import { notification } from "antd";

import { AppNotificationContext } from "./app-notification.context";

export const AppNotificationProvider = ({
  children,
}: AppNotificationProviderProps) => {
  const [api, contextHolder] = notification.useNotification();

  return (
    <AppNotificationContext.Provider value={{ api, contextHolder }}>
      {children}
    </AppNotificationContext.Provider>
  );
};
